<template>
  <div>
    <div class="row success">
      <div class="col-xl-8">
        <h5 class="mb-4">{{ $t("decisionConseil.editorTitle") }}</h5>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <label>{{ $t("bulletin.listeClasses") }}</label>
        <a-select
          show-search
          :placeholder="$t('emploi.listeClasses')"
          v-model="selectedClasse"
          style="width: 200px; margin-left: 15px"
          :loading="classroomLoading"
          :disabled="classroomLoading"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="classroom in classrooms"
            :key="classroom._id"
            :value="classroom._id"
          >
            {{ classroom.name }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <DecisionConseilEditor
      v-if="selectedClasse"
      :classroomID="selectedClasse"
      :type="type"
      :level="selectedLevel"
    />
  </div>
</template>

<script>
import apiClient from "@/services/axios";
import DecisionConseilEditor from "./DecisionConseilEditor.vue";

export default {
  name: "DecisionConseilTab",
  components: { DecisionConseilEditor },
  props: {
    type: { type: String, required: true },
  },
  data() {
    return {
      classrooms: [],
      selectedClasse: null,
      classroomLoading: false,
    };
  },
  async created() {
    await this.getClassrooms();
  },
  computed:{
    selectedLevel(){
      if (!this.selectedClasse) return 6
      else return this.classrooms.find((classroom)=>classroom._id==this.selectedClasse)?.level || 6
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async getClassrooms() {
      this.classroomLoading = true;
      try {
        const { data } = await apiClient.post("/classrooms/filter", {
          query: { status: "active" },
          aggregation: {
            $project: { _id: 1, name: 1, level: 1 },
          },
        });
        this.classrooms = data;
      } catch (error) {
        this.$message.error(this.$t("error.erreur"));
      } finally {
        this.classroomLoading = false;
      }
    },
  },
};
</script>
